import React, { useEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoDark from "../../../assets/images/logo-dark.png";
import moment from "moment";
const PrintDoc = ({ innerRef, item, type }) => {
  const handleValidDate = (date) => {
    return moment.utc(date).local().format("MMM D, YYYY");
  }

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <Card>
          <Col lg={12}>
            <CardHeader className="border-bottom-dashed p-4">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                  {/* <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" /> */}
                  <div className="mt-sm-3 mt-3">
                    <h6 className="text-uppercase fw-semibold">{item.client && item.client.label}</h6>
                    <p className="mb-1">{item.company && item.company.label}</p>
                    <p className="mb-1">{item.department && item.department.label}</p>
                    {/* <h6 className="text-uppercase fw-semibold">{info.purchase_company && info.purchase_company.name}</h6>
                    <p className="mb-1">{info.purchase_department && info.purchase_department.name}</p> */}
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardBody className="p-4">
              <Row className="g-3">
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                  <h5 className="fs-14 mb-0">
                    #<span id="invoice-no">{item.code}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                  <h5 className="fs-14 mb-0">
                    <span id="invoice-date">{handleValidDate(item.date)}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                  <h5 className="fs-14 mb-0">
                    <span id="invoice-date">{handleValidDate(item.dueat)}</span>
                  </h5>
                </Col>
                <Col lg={3} xs={3}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Total Amount</p>
                  <h5 className="fs-14 mb-0">
                    <span id="total-amount">{currencyFormat(item.total_amount)}</span>
                  </h5>
                </Col>
              </Row>
            </CardBody>
            <CardBody className="p-4">
              <div className="table-responsive">
                <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                  <thead>
                    <tr className="table-active">
                      <th scope="col" style={{ width: "50px" }}>
                        #
                      </th>
                      <th scope="col">Detail Produk</th>
                      <th scope="col">Rate</th>
                      <th scope="col">Quantity</th>
                      <th scope="col" className="text-end">
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody id="products-list">
                    {(item.sales_detail || []).map((o, i) => {
                      return (
                        <tr key={i} id={i} className="product">
                          <th scope="row" className="product-id">
                            {i + 1}
                          </th>
                          <td className="text-start">{o.name}</td>
                          <td>{currencyFormat(o.amount)}</td>
                          <td>{o.quantity}</td>
                          <td className="text-end">{currencyFormat(o.quantity * o.amount)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <div className="border-top border-top-dashed mt-2">
                <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                  <tbody>
                    <tr>
                      <td>Sub Total</td>
                      <td className="text-end">{currencyFormat(item.sub_amount)}</td>
                    </tr>
                    <tr>
                      <td>Diskon</td>
                      <td className="text-end">{currencyFormat(item.disc_amount)}</td>
                    </tr>
                    <tr>
                      <td>Biaya Kirim</td>
                      <td className="text-end">{currencyFormat(item.shipment_amount)}</td>
                    </tr>
                    <tr>
                      <td>Pajak ({item.tax ? item.tax.amount : 0}%)</td>
                      <td className="text-end">{currencyFormat(item.tax_amount)}</td>
                    </tr>
                    <tr className="border-top border-top-dashed fs-15">
                      <th scope="row">Total Amount</th>
                      <th className="text-end">{JSON.stringify(item)}</th>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className="mt-4">
                <div className="alert alert-info">
                  <p className="mb-0">
                    <span className="fw-semibold">NOTES:</span>
                    <span id="note"> {item.description}</span>
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <div>
                  <p className="mb-0">{item.user}</p>
                </div>
              </div>
            </CardBody>
          </Col>
        </Card>
      </div>
    </div>
  );
};

export default PrintDoc;